import styled from 'styled-components';

import {
  Accordion as SemanticAccordion,
  Icon as SemanticIcon,
  Image,
} from 'semantic-ui-react';

import { Text as TextComponent, Loader as LoaderLayoutComponent, ScrollBarContainer } from '@playbookux/playbook-web-core';
import SearchField from '../../../core/layout-components/search';

export const Container = styled.div`
  padding: 20px;
  background-color: ${(props) => props.theme.color.white};
  border: 1px solid ${(props) => props.theme.color.searchInputBorder};
  user-select: none;
  border-radius: 5px;
`;

export const Search = styled(SearchField).attrs({
  width: '100%',
})`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(TextComponent.Muted)`
  user-select: none;
`;

export const ContainerTitle = styled.div`
  padding: 10px 5px 5px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Accordion = styled(SemanticAccordion)``;

export const ContainerTags = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
`;

export const Icon = styled(SemanticIcon)``;

export const AccordionTitleText = styled(TextComponent.Secondary)`
  cursor: pointer;
  user-select: none;
`;

export const ContainerTag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 5px 0;
  align-items: flex-start;
`;

export const Link = styled.a``;

export const Scroll = styled(ScrollBarContainer)``;

export const ScrollContainer = styled.div`
  height: 200px;
  width: 100%;
`;

export const ScrollContent = styled.div`
  padding-bottom: 40px;
  user-select: none;
`;

export const Reactions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ContainerIcons = styled.div`
  flex: 1;
  padding: 3px;
  display: flex;
`;

export const BackgroundIcon = styled.div`
  background-color: ${(props) => props.backgroundColor};
  display: flex;
  width: 100%;
  border-radius: 5px;
  border: ${(props) => (props.active ? '1px solid #477ae9' : '')};
  cursor: pointer;
`;

export const ReactionIcon = styled(Image)`
  margin: auto;
  height: 50%;
`;

export const ContainerMessage = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Message = styled(TextComponent)``;

export const Loader = styled(LoaderLayoutComponent)``;

export const ContainerLoader = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
`;
